import { AnyObject } from 'src/types/generics';

const getObjectKeys = <T extends AnyObject, K extends keyof T>(arg: T): K[] => {
  return Object.keys(arg) as K[];
};

export { getObjectKeys };
